"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiInput = _interopRequireDefault(require("@tencent/spaui-input"));

var _spauiFormgroup = _interopRequireDefault(require("@tencent/spaui-formgroup"));

var _selected_tip_component = _interopRequireDefault(require("./component/selected_tip_component"));

var _img_component = _interopRequireDefault(require("./component/img_component"));

var _info_component = _interopRequireDefault(require("./component/info_component"));

var _user_item_component = _interopRequireDefault(require("./component/user_item_component"));

var _empty_component = _interopRequireDefault(require("./component/empty_component"));

var _split_component = _interopRequireDefault(require("./component/split_component"));

var _action_component = _interopRequireDefault(require("./component/action_component"));

var _title_component = _interopRequireDefault(require("./component/title_component"));

var _checkall_component = _interopRequireDefault(require("./component/checkall_component"));

var _leftPanelComponent = _interopRequireDefault(require("./component/left-panel-component"));

var _rightPanelComponent = _interopRequireDefault(require("./component/right-panel-component"));

var _info = _interopRequireDefault(require("./info"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = require("./utils/index");

var _compact_props = _interopRequireDefault(require("./utils/compact_props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Picker =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Picker, _PureComponent);

  /**
   * 组件属性说明
   * @alias PickerProps
   * @description 选择导入用户组件。
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基本属性
   * @property {array} data=[]] 数据
   * @property {array} value=[]] 选中的数据
   * @property {func} onChange 添加数据变更<br />onChange(event, value)
   * @property {bool} [checkAll=false] 是否需要全选按钮
   * @property {string} [checkAllLabel='全选'] 全选的提示文案
   * @property {func} [onCheckAllChange] 全选操作回调（设置后即接管CheckAll的回调事件）
   * @property {string} [valueKey='name'] 作为判断选中依据的字段
   * @property {string} [valueType='auto'] value为何种格式*可选值：auto, object, nonObject*
   * @property {bool} [disabled=false] 是否禁用
   * @property {number} [ellipsisCount=22] 描述大于几个字符时进行省略
   * @property {titleline} 导入相关属性
   * @property {bool} [canImport=false] 是否需要批量导入
   * @property {string} [importLabel='批量导入客户'] 批量导入按钮文案
   * @property {func} [onShowImport] 点击批量导入回调
   * @property {titleline} 异步加载属性
   * @property {bool} [asyncLoading=false] 是否需要异步加载
   * @property {func} [onLoad] 点击加载更多回调
   * @property {string} [loadButtonLabel='加载更多'] 异步加载按钮文案
   * @property {titleline} 搜索属性
   * @property {bool} [search=true] 是否需要搜索
   * @property {string} [searchPlaceholder='请输入要筛选的关键词'] 搜索提示
   * @property {string} [searchValue] 搜索的内容
   * @property {bool} [useDefaultSearchLogic=true] 是否使用默认搜索匹配逻辑(为false时直接显示data)
   * @property {array} [searchFields=['name']] 搜索的字段，默认为name
   * @property {func} [searchFilter] 自定义筛选逻辑(searchFilter=(searchValue='', itemData = {}))
   * @property {func} [convertPYs] 拼音转化，对应@tencent/spa-pinyin
   * @property {func} [onSearchChange] 搜索回调(onSearchChange=(event,value))
   * @property {string} [searchPanelClassName] 顶部搜索栏的 className
   * @property {titleline} 自定组件属性
   * @property {element|func} [SearchInputLeftComponent] 搜索输入框左侧组件
   * @property {func} [SelectedTipComponent] 选中面板标题文案提示组件
   * @property {func} [UserItemComponent] 列表元素节点组件
   * @property {func} [OptionUserItemComponent] 选择面板中列表元素节点组件*可单独设置左右面板*
   * @property {func} [SelectionUserItemComponent] 选中面板中列表元素节点组件*可单独设置左右面板*
   * @property {func} [ImgComponent] UserItemComponent中的img结构
   * @property {func} [InfoComponent] UserItemComponent中的Info信息结构
   * @property {func} [EmptyComponent] 没有选中数据提示组件
   * @property {func} [SplitComponent] 分隔符组件
   * @property {func} [ActionComponent] 操作区域组件
   * @property {element|func} [TitleComponent] 标题组件
   * @property {func} [CheckAllComponent] 全选组件
   * @property {titleline} 可选区域属性
   * @property {string} [optionalEmptyLabel=''] 可选区域为空提示文案
   * @property {titleline} 选择区域属性
   * @property {bool} [onlySelection=false] 只有选择区域
   * @property {bool} [selectionHeader=true] 是否需要选择的头部
   * @property {string} [selectionTitle='已选择关注人'] 已选择区域标题
   * @property {string} [selectionEmptyLabel='请在左侧选择添加关注人员'] 已选择区域为空提示文案
   * @property {titleline} 内嵌组件属性
   * @property {object} [InputProps={}] Input组件的props配置
   * @property {any} [userListAddon=null] 左侧面板附加内容
   * @property {any} [selectionListAddon=null] 右侧面板附加内容
   */
  function Picker(props) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleCheckAllChange", function (event) {
      var _this$props = _this.props,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? [] : _this$props$value,
          _this$props$valueKey = _this$props.valueKey,
          valueKey = _this$props$valueKey === void 0 ? '' : _this$props$valueKey,
          onChange = _this$props.onChange,
          _this$props$valueType = _this$props.valueType,
          valueType = _this$props$valueType === void 0 ? '' : _this$props$valueType,
          onCheckAllChange = _this$props.onCheckAllChange;

      var checkAllStatus = _this.getCheckAllStatus();

      var result = [];

      var _assertThisInitialize = _assertThisInitialized(_this),
          itemIsObjectByValue = _assertThisInitialize.itemIsObjectByValue;

      var dataBySearchValue = (0, _index.getDataBySearchValue)(_this.state.searchValue, _this.props);

      if (valueType === 'object') {
        itemIsObjectByValue = true;
      } else if (valueType === 'nonObject') {
        itemIsObjectByValue = false;
      }

      if (checkAllStatus !== 'checked') {
        result = (0, _index.cloneArray)(value); // 选择全部，将经过 searchValue 过滤过的值加入选中的数据中（如果该选项为 disabled 则不加入）

        dataBySearchValue.forEach(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (item[valueKey] || typeof item[valueKey] === 'number') {
            var index = (0, _index.inDataIndex)(value, item, valueKey);

            if (index < 0 && !item.disabled) {
              if (itemIsObjectByValue) {
                result.push((0, _spauiUtils.objectAssign)(item));
              } else {
                result.push(item[valueKey]);
              }
            }
          }
        });
      }

      if (checkAllStatus === 'checked') {
        // 取消全选，应该只取消存在当前 data 中的值（经过 searchValue 过滤过的值）
        result = (0, _index.cloneArray)(value);
        dataBySearchValue.forEach(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (item[valueKey] || typeof item[valueKey] === 'number') {
            if (itemIsObjectByValue) {
              (0, _index.removeItemFromArray)(result, '', function () {
                var resultItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return resultItem[valueKey] === item[valueKey];
              });
            } else {
              (0, _index.removeItemFromArray)(result, item[valueKey]);
            }
          }
        });
      }

      if ((0, _spauiUtils.isFunction)(onCheckAllChange)) {
        onCheckAllChange(event, checkAllStatus);
      } else if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, result);
      }
    });

    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleSearchChange = _this.handleSearchChange.bind(_assertThisInitialized(_this));
    _this.documentKeyDown = _this.documentKeyDown.bind(_assertThisInitialized(_this));
    _this.itemIsObjectByValue = (0, _index.itemIsObjectByValue)(props.value);

    _this.setUnFocus();

    _this.state = {
      searchValue: props.searchValue || ''
    };

    _this.nullList();

    return _this;
  }

  _createClass(Picker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setUnFocus();

      if (this.focus) {
        this.updateFocus();
      }

      if (_index.haveJQuery) {
        jQuery(document).on('keydown', this.documentKeyDown);
      } else if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.addEventListener)) {
        document.addEventListener('keydown', this.documentKeyDown);
      }

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var value = nextProps.value,
          searchValue = nextProps.searchValue;

      if (typeof value !== 'undefined' && !this.itemIsObjectByValue && value.length > 0) {
        this.itemIsObjectByValue = (0, _index.itemIsObjectByValue)(value);
      }

      if (typeof searchValue !== 'undefined') {
        this.setState({
          searchValue: searchValue
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.focus) {
        this.updateFocus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();

      if (_index.haveJQuery) {
        jQuery(document).off('keydown', this.documentKeyDown);
      } else if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.removeEventListener)) {
        document.removeEventListener('keydown', this.documentKeyDown);
      }
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.userlistRef = null;
    }
  }, {
    key: "documentKeyDown",
    value: function documentKeyDown(event) {
      var _this$props2 = this.props,
          value = _this$props2.value,
          valueKey = _this$props2.valueKey;
      var dataBySearchValue = (0, _index.getDataBySearchValue)(this.state.searchValue, this.props);
      var keyCode = event.keyCode;
      var focusIndex = this.focusIndex;
      var result = focusIndex;
      var status = 'add';
      var data = {};

      if (dataBySearchValue.length < 1) {
        this.focusIndex = 0;
        focusIndex = this.focusIndex;
        result = this.focusIndex;
      }

      if (this.focus) {
        if (keyCode === 40) {
          // 方向键往下
          if (focusIndex < dataBySearchValue.length - 1) {
            result = focusIndex + 1;
          } else {
            result = 0;
          }
        } else if (keyCode === 38) {
          // 方向键往上
          if (focusIndex < 0) {
            result = dataBySearchValue.length - 1;
          } else {
            result = focusIndex - 1;
          }
        } // 更新焦点


        if (result !== focusIndex) {
          this.focusIndex = result;
          this.updateFocus();
        } // 回车


        if (keyCode === 13 && result > -1) {
          data = dataBySearchValue[result];

          if (data || typeof data === 'number') {
            status = (0, _index.inDataIndex)(value, data, valueKey) > -1 ? 'delete' : 'add';
            this.handleChange(event, status, data);
          }
        }
      }
    } // 数据变更回调

  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _this$props3 = this.props,
          onChange = _this$props3.onChange,
          disabled = _this$props3.disabled,
          _this$props3$value = _this$props3.value,
          value = _this$props3$value === void 0 ? [] : _this$props3$value,
          valueKey = _this$props3.valueKey,
          _this$props3$valueTyp = _this$props3.valueType,
          valueType = _this$props3$valueTyp === void 0 ? '' : _this$props3$valueTyp;
      var result = (0, _index.cloneArray)(value);
      var index = -1;
      var itemIsObjectByValue = this.itemIsObjectByValue;

      if (valueType === 'object') {
        itemIsObjectByValue = true;
      } else if (valueType === 'nonObject') {
        itemIsObjectByValue = false;
      } // 优先看选项是否 disabled


      if (!(data.disabled || disabled)) {
        switch (status) {
          case 'add':
            if (data[valueKey] || typeof data[valueKey] === 'number') {
              if (itemIsObjectByValue) {
                result.push((0, _spauiUtils.objectAssign)(data));
              } else {
                result.push(data[valueKey]);
              }
            }

            break;

          case 'checked':
          case 'delete':
            index = (0, _index.inDataIndex)(value, data, valueKey);

            if (index > -1) {
              result.splice(index, 1);
            }

            break;

          case 'clear':
            {
              // 选项如果是 disabled 的话，则该选项是禁止操作的
              result = [];
              var dataByValue = (0, _index.getDataByValue)(this.props);
              dataByValue.forEach(function (item) {
                if (!item.disabled) {
                  return;
                }

                if (item[valueKey] || typeof item[valueKey] === 'number') {
                  if (itemIsObjectByValue) {
                    result.push((0, _spauiUtils.objectAssign)(item));
                  } else {
                    result.push(item[valueKey]);
                  }
                }
              });
              break;
            }
        }

        if ((0, _spauiUtils.isFunction)(onChange)) {
          onChange(event, result);
        }
      }
    }
  }, {
    key: "handleSearchChange",
    // 搜索回调
    value: function handleSearchChange(event, customValue) {
      var _this$props4 = this.props,
          onSearchChange = _this$props4.onSearchChange,
          searchValue = _this$props4.searchValue;
      var result = event.target.value; // 指定了值，优先用指定的

      if (typeof customValue !== 'undefined') {
        result = customValue;
      } // 如果外部没有指定，组件自带处理


      if (typeof searchValue === 'undefined') {
        this.setState({
          searchValue: result
        });
      } // 搜索的化，默认都是第一个


      this.focusIndex = 0;
      this.updateFocus();

      if ((0, _spauiUtils.isFunction)(onSearchChange)) {
        onSearchChange(event, result);
      }
    } // 去除焦点

  }, {
    key: "setUnFocus",
    value: function setUnFocus() {
      this.focus = false;
      this.focusIndex = -1;
      this.updateFocus();
    } // 更新焦点信息

  }, {
    key: "updateFocus",
    value: function updateFocus() {
      var focusIndex = this.focusIndex;
      var liItem = null;
      var i = 0;
      var len = 0;

      if (this.userlistRef) {
        liItem = this.userlistRef.getElementsByTagName('li'); // 先全部除去focus class

        i = 0;
        len = liItem.length;

        for (; i < len; i++) {
          if (liItem[i]) {
            liItem[i].className = (0, _index.removeFocusClassName)(liItem[i].className);
          }
        }

        if (focusIndex > -1 && liItem[focusIndex]) {
          liItem[focusIndex].className = "".concat(liItem[focusIndex].className, " focus");
        }
      }
    }
  }, {
    key: "getCheckAllStatus",
    value: function getCheckAllStatus() {
      var _this$props5 = this.props,
          _this$props5$value = _this$props5.value,
          value = _this$props5$value === void 0 ? [] : _this$props5$value,
          _this$props5$valueKey = _this$props5.valueKey,
          valueKey = _this$props5$valueKey === void 0 ? '' : _this$props5$valueKey;
      var result = '';
      var isCheckAll = false;
      var isIndeterminate = false;
      var dataBySearchValue = (0, _index.getDataBySearchValue)(this.state.searchValue, this.props);

      if (dataBySearchValue.length > 0) {
        isCheckAll = true;
        dataBySearchValue.forEach(function (item) {
          var status = (0, _index.inDataIndex)(value, item, valueKey) > -1 ? 'checked' : '';

          if (status || !status && item.disabled) {
            isIndeterminate = true;
          } else if (!status) {
            isCheckAll = false;
          }
        });
      }

      if (isCheckAll) {
        result = 'checked';
      } else if (isIndeterminate) {
        result = 'indeterminate';
      }

      return result;
    }
  }, {
    key: "genAddonContent",
    value: function genAddonContent(Addon) {
      if ((0, _spauiUtils.isReactNode)(Addon)) {
        return Addon;
      }

      return _react["default"].createElement(Addon, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          _this$props6$searchPl = _this$props6.searchPlaceholder,
          searchPlaceholder = _this$props6$searchPl === void 0 ? '' : _this$props6$searchPl,
          onChange = _this$props6.onChange,
          disabled = _this$props6.disabled,
          _this$props6$value = _this$props6.value,
          value = _this$props6$value === void 0 ? [] : _this$props6$value,
          onLoad = _this$props6.onLoad,
          onShowImport = _this$props6.onShowImport,
          selectionHeader = _this$props6.selectionHeader,
          loadButtonLabel = _this$props6.loadButtonLabel,
          _this$props6$selectio = _this$props6.selectionTitle,
          selectionTitle = _this$props6$selectio === void 0 ? '' : _this$props6$selectio,
          _this$props6$importLa = _this$props6.importLabel,
          importLabel = _this$props6$importLa === void 0 ? '' : _this$props6$importLa,
          convertPYs = _this$props6.convertPYs,
          SelectionUserItemComponent = _this$props6.SelectionUserItemComponent,
          OptionUserItemComponent = _this$props6.OptionUserItemComponent,
          UserItemComponent = _this$props6.UserItemComponent,
          SplitComponent = _this$props6.SplitComponent,
          ActionComponent = _this$props6.ActionComponent,
          InputProps = _this$props6.InputProps,
          search = _this$props6.search,
          onlySelection = _this$props6.onlySelection,
          valueKey = _this$props6.valueKey,
          TitleComponent = _this$props6.TitleComponent,
          SelectedTipComponent = _this$props6.SelectedTipComponent,
          _this$props6$checkAll = _this$props6.checkAll,
          checkAll = _this$props6$checkAll === void 0 ? false : _this$props6$checkAll,
          CheckAllComponent = _this$props6.CheckAllComponent,
          LeftPanelComponent = _this$props6.LeftPanelComponent,
          RightPanelComponent = _this$props6.RightPanelComponent,
          searchPanelClassName = _this$props6.searchPanelClassName,
          SearchInputLeftComponent = _this$props6.SearchInputLeftComponent,
          _this$props6$userList = _this$props6.userListAddon,
          userListAddon = _this$props6$userList === void 0 ? null : _this$props6$userList,
          _this$props6$selectio2 = _this$props6.selectionListAddon,
          selectionListAddon = _this$props6$selectio2 === void 0 ? null : _this$props6$selectio2;

      var _compactProps = (0, _compact_props["default"])(this.props),
          asyncLoading = _compactProps.asyncLoading,
          canImport = _compactProps.canImport;

      var _this$state$searchVal = this.state.searchValue,
          searchValue = _this$state$searchVal === void 0 ? '' : _this$state$searchVal;
      var dataBySearchValue = (0, _index.getDataBySearchValue)(this.state.searchValue, this.props);
      var dataByValue = (0, _index.getDataByValue)(this.props);
      var checkAllStatus = this.getCheckAllStatus();
      var titleComponentDom = null;

      if (dataBySearchValue.length < 1) {
        this.focusIndex = 0;
      }

      if (typeof TitleComponent !== 'undefined' && (0, _spauiUtils.isReactNode)(TitleComponent)) {
        titleComponentDom = TitleComponent;
      }

      var searchInputLeftComponent = null;

      if (typeof SearchInputLeftComponent !== 'undefined' && SearchInputLeftComponent) {
        if ((0, _spauiUtils.isReactNode)(SearchInputLeftComponent)) {
          searchInputLeftComponent = SearchInputLeftComponent;
        } else {
          searchInputLeftComponent = _react["default"].createElement(SearchInputLeftComponent, this.props);
        }
      }

      var searchInputProps = _objectSpread({
        disabled: disabled,
        placeholder: searchPlaceholder,
        value: searchValue,
        onChange: this.handleSearchChange,
        onFocus: function onFocus() {
          _this2.focus = true;
        },
        onBlur: function onBlur() {
          return _this2.setUnFocus();
        }
      }, InputProps);

      var titleComponent = titleComponentDom ? titleComponentDom : _react["default"].createElement(TitleComponent, _extends({}, this.props, {
        type: "options_panel"
      }));
      var LeftPanelItemComponent = null;

      if (!(0, _spauiUtils.isUndefined)(OptionUserItemComponent)) {
        LeftPanelItemComponent = OptionUserItemComponent;
      } else {
        LeftPanelItemComponent = UserItemComponent;
      }

      var checkAllProps = _objectSpread({}, this.props, {
        checked: checkAllStatus === 'checked',
        indeterminate: checkAllStatus === 'indeterminate',
        onChange: this.handleCheckAllChange
      });

      var setListRef = function setListRef(el) {
        _this2.userlistRef = el;
      };

      var getItemStatus = function getItemStatus(item) {
        return (0, _index.inDataIndex)(value, item, valueKey) > -1 ? 'checked' : 'add';
      };

      var searchComponent = null;

      if (search) {
        searchComponent = _react["default"].createElement("div", {
          className: (0, _classnames["default"])('user-picker-header spaui-userpicker-header', searchPanelClassName)
        }, searchInputLeftComponent, _react["default"].createElement(_spauiFormgroup["default"], {
          clearable: searchValue.length > 0,
          clear: searchValue.length > 0,
          onClear: function onClear(event) {
            return _this2.handleSearchChange(event, '');
          }
        }, _react["default"].createElement(_spauiInput["default"], searchInputProps)));
      }

      var checkAllComponent = null;

      if (checkAll) {
        checkAllComponent = _react["default"].createElement(CheckAllComponent, checkAllProps);
      }

      var addonContent = this.genAddonContent(userListAddon);
      var asnycLoadComponent = null;

      if (asyncLoading && !disabled) {
        asnycLoadComponent = _react["default"].createElement("a", {
          className: "feed-more spaui-userpicker-feed-more spaui-cursor-pointer",
          onClick: onLoad
        }, loadButtonLabel);
      }

      var selectionHeaderComponent = null;

      if (selectionHeader) {
        selectionHeaderComponent = _react["default"].createElement("div", {
          className: "user-picker-header spaui-userpicker-header"
        }, _react["default"].createElement("div", {
          className: "titlebar"
        }, _react["default"].createElement(SelectedTipComponent, _extends({}, this.props, {
          label: selectionTitle,
          selectionTitle: selectionTitle,
          data: dataByValue
        })), _react["default"].createElement(ActionComponent, _extends({}, this.props, {
          importable: canImport,
          "import": canImport,
          importLabel: importLabel,
          onShowImport: onShowImport,
          data: value,
          disabled: disabled,
          onClear: function onClear(event) {
            _this2.handleChange(event, 'clear');
          },
          onChange: onChange
        }))));
      }

      var selectionTitleComponent = titleComponentDom ? titleComponentDom : _react["default"].createElement(TitleComponent, _extends({}, this.props, {
        type: "selected_panel",
        data: dataByValue
      }));
      var RightPanelItemComponent = null;

      if (!(0, _spauiUtils.isUndefined)(SelectionUserItemComponent)) {
        RightPanelItemComponent = SelectionUserItemComponent;
      } else {
        RightPanelItemComponent = UserItemComponent;
      }

      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: 'spaui-userpicker user-picker'
      }, Picker), !onlySelection ? _react["default"].createElement(LeftPanelComponent, _extends({}, this.props, {
        searchInputProps: searchInputProps,
        searchComponent: searchComponent,
        titleComponent: titleComponent,
        panelClassName: "user-picker-item spaui-userpicker-item user",
        data: dataBySearchValue,
        rawData: this.props.data,
        checkAllProps: checkAllProps,
        checkAllComponent: checkAllComponent,
        setListRef: setListRef,
        ItemComponent: LeftPanelItemComponent,
        getItemStatus: getItemStatus,
        searchValue: searchValue,
        convertPYs: convertPYs,
        onItemChange: this.handleChange,
        addonContent: addonContent,
        asnycLoadComponent: asnycLoadComponent
      })) : null, !onlySelection ? _react["default"].createElement("div", {
        className: "user-picker-split spaui-userpicker-split"
      }, _react["default"].createElement(SplitComponent, _extends({}, this.props, {
        type: "icon"
      }))) : null, _react["default"].createElement(RightPanelComponent, _extends({}, this.props, {
        panelClassName: "user-picker-item spaui-userpicker-item selection",
        headerComponent: selectionHeaderComponent,
        titleComponent: selectionTitleComponent,
        addonContent: this.genAddonContent(selectionListAddon),
        ItemComponent: RightPanelItemComponent,
        onItemChange: this.handleChange,
        data: dataByValue,
        rawData: this.props.data,
        onClear: function onClear(event) {
          _this2.handleChange(event, 'clear');
        }
      })));
    }
  }]);

  return Picker;
}(_react.PureComponent); // 组件标记


_defineProperty(Picker, "propTypes", {
  data: _spauiUtils.PropTypes.array.isRequired,
  value: _spauiUtils.PropTypes.array.isRequired,
  onChange: _spauiUtils.PropTypes.func.isRequired,
  checkAll: _spauiUtils.PropTypes.bool,
  checkAllLabel: _spauiUtils.PropTypes.any,
  onCheckAllChange: _spauiUtils.PropTypes.func,
  valueKey: _spauiUtils.PropTypes.string,
  valueType: _spauiUtils.PropTypes.string,
  search: _spauiUtils.PropTypes.bool,
  searchPlaceholder: _spauiUtils.PropTypes.string,
  searchValue: _spauiUtils.PropTypes.string,
  useDefaultSearchLogic: _spauiUtils.PropTypes.bool,
  searchFields: _spauiUtils.PropTypes.array,
  searchFilter: _spauiUtils.PropTypes.func,
  convertPYs: _spauiUtils.PropTypes.func,
  searchPanelClassName: _spauiUtils.PropTypes.string,
  onSearchChange: _spauiUtils.PropTypes.func,
  asyncLoading: _spauiUtils.PropTypes.bool,
  onLoad: _spauiUtils.PropTypes.func,
  loadButtonLabel: _spauiUtils.PropTypes.string,
  canImport: _spauiUtils.PropTypes.bool,
  disabled: _spauiUtils.PropTypes.bool,
  onShowImport: _spauiUtils.PropTypes.func,
  importLabel: _spauiUtils.PropTypes.string,
  ellipsisCount: _spauiUtils.PropTypes.number,
  onlySelection: _spauiUtils.PropTypes.bool,
  selectionHeader: _spauiUtils.PropTypes.bool,
  selectionTitle: _spauiUtils.PropTypes.string,
  optionalEmptyLabel: _spauiUtils.PropTypes.string,
  selectionEmptyLabel: _spauiUtils.PropTypes.string,
  CheckAllComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  SearchInputLeftComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  SelectedTipComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  ImgComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  OptionUserItemComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  SelectionUserItemComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  InfoComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  UserItemComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  EmptyComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  SplitComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  ActionComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  TitleComponent: _spauiUtils.PropTypes.oneOfType([_spauiUtils.PropTypes.element, _spauiUtils.PropTypes.func]),
  InputProps: _spauiUtils.PropTypes.object,
  userListAddon: _spauiUtils.PropTypes.any,
  selectionListAddon: _spauiUtils.PropTypes.any
});

_defineProperty(Picker, "defaultProps", {
  data: [],
  value: [],
  checkAll: false,
  checkAllLabel: '全选',
  valueKey: 'name',
  valueType: 'auto',
  search: true,
  searchPlaceholder: '请输入要筛选的关键词',
  searchPanelClassName: '',
  useDefaultSearchLogic: true,
  asyncLoading: false,
  canImport: false,
  disabled: false,
  ellipsisCount: 22,
  importLabel: '批量导入客户',
  loadButtonLabel: '加载更多',
  onlySelection: false,
  selectionHeader: true,
  selectionTitle: '已选择关注人',
  optionalEmptyLabel: '',
  selectionEmptyLabel: '请在左侧选择添加关注人员',
  searchFields: ['name'],
  InputProps: {},
  SelectedTipComponent: _selected_tip_component["default"],
  UserItemComponent: _user_item_component["default"],
  ImgComponent: _img_component["default"],
  InfoComponent: _info_component["default"],
  ActionComponent: _action_component["default"],
  SplitComponent: _split_component["default"],
  EmptyComponent: _empty_component["default"],
  TitleComponent: _title_component["default"],
  CheckAllComponent: _checkall_component["default"],
  LeftPanelComponent: _leftPanelComponent["default"],
  RightPanelComponent: _rightPanelComponent["default"],
  userListAddon: null,
  selectionListAddon: null
});

(0, _spauiUtils.setComponentMark)(Picker, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Picker;
exports["default"] = _default;